import { useCallback, useEffect, useState } from "react";
import { getAuthToken } from "../api/axios";
import { fetchActiveCompanyOffices } from "../utils/workplaceUtils";

export function useCompanyWorkplaces() {
  const [loading, setLoading] = useState(true);
  const [offices, setOffices] = useState([]);

  const refresh = useCallback(async () => {
    // Skip when logged out (e.g. Header mounts on "/" after logout) to avoid
    // firing an unauthenticated GetCompanyOffices request that returns 401.
    if (!getAuthToken()?.accessToken) {
      setOffices([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      const list = await fetchActiveCompanyOffices();
      setOffices(list);
    } catch {
      setOffices([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
    const onChanged = () => refresh();
    window.addEventListener("company-offices-changed", onChanged);
    return () => window.removeEventListener("company-offices-changed", onChanged);
  }, [refresh]);

  return {
    loading,
    offices,
    hasWorkplaces: offices.length > 0,
    refresh,
  };
}
